<template>
  <div class="mecanismos">
    <nav :class="{'active': menu}">
      <div class="nav-mobile">
        <router-link to="/portfolio">Portfolio</router-link>
        <router-link to="/atelier">Atelier </router-link> 
        <router-link to="/registos">Registos</router-link> 
        <router-link to="/contactos">Contactos</router-link>
      </div>
      <div class="nav-left">
        <router-link to="/portfolio">Portfolio </router-link> 
        <span class="separador">&nbsp;</span>
        <router-link to="/atelier">Atelier </router-link> 
        <span class="separador">&nbsp;</span>
        <span class="current">Registos</span>
      </div>
      <div class="nav-right">
        <router-link to="/contactos">Contactos</router-link>
      </div>
    </nav>

    <div class="open-menu">
      <div @click="menu = true">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <carousel class="mecanismos-carousel" :navigationEnabled="true" :perPage="1" :paginationEnabled="false">
      <slide class="mecanismos-slide" v-for="mecanismo in mecanismos" :key="mecanismo.id">
          <div class="img" :style="{ backgroundImage: 'url(\'' + 'http://atelieradaoparanhos.com' + mecanismo.imagem + '\')' }"></div>
          <div class="desc" v-html="mecanismo.descricao">
          </div>
      </slide>
    </carousel>

  </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel'
import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
  name: 'Registos',
  data () {
    return {
      menu: false,
      mecanismos: [
      ]
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    loadMecanismos: function () {
      var app = this
      axios.get('/admin/api/mecanismos').then((response) => {
        app.mecanismos = response.data
      })
    }
  },
  mounted: function () {
    this.loadMecanismos()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">


.mecanismos {
  .nav-left span.current {
  }

  &-carousel {
    .VueCarousel-slide {
      height: calc(100vh - 120px);
    }
  }
  &-title {
    background: black;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-slide {
      height: 100%;
      .img {
        height: 60vh;
        background-position: center;
        background-size: cover;
      }
      .desc {
        font-family: Georgia;
        color: #6e6e6e;
        font-size: 10px;
        margin: 0 auto;
        height: 50px;
        max-width: 1920px;
        p {
            padding-top: 20px;
            float: left;
            margin-left: 200px;
            float: left;
            max-width: 470px;
        }
      }
  }
}
  
@media (min-width: 1920px) {
  .mecanismos-slide .desc {
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
